import axios from 'axios'
import {Cookies, deleteCookie} from "./cookies";
import {redirectToKeycloakLogin} from "./keycloak";


// Create axios instance with base configuration
export const apiRequest = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL || 'http://localhost:8080/giro/api/v1',
  timeout: 10000,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  }
})

// Create a function to set the store reference after store is created
let storeRef: any = null;
export const setStoreRef = (store: any) => {
  storeRef = store;
};

apiRequest.interceptors.request.use(
  (config) => {
    if (storeRef) {
      const state = storeRef.getState()
      const token = state.session.token

      if (token) {
        config.headers.Authorization = `Bearer ${token}`
      }
    }
    return config
  },
  (error) => Promise.reject(error)
)

apiRequest.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      deleteCookie(Cookies.AUTH_SUCCESS);
      redirectToKeycloakLogin();
    }
    return Promise.reject(error)
  }
)
